import actions from '../../actionTypes';

export default data => {
  return {
    type: actions.SET_RP_DETAIL,
    referencePointData: data
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/setRpDetail.js